import script from "./ContentAdvertising.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContentAdvertising.vue?vue&type=script&setup=true&lang=ts"

import "./ContentAdvertising.vue?vue&type=style&index=0&id=5e84b4da&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e84b4da"]])

export default __exports__